import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { IMessageResponseDto, ICreateStylesDto, IAccountStylesRespDto } from 'src/types'

class AccountStylesService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getAccountStyles(accountId: string) {
    return this.get<IAccountStylesRespDto>(`accounts/styles/${accountId}`)
  }

  createStyling(dto: ICreateStylesDto) {
    const formData = new FormData()
    if (dto.file) {
      formData.append('file', dto.file)
    }
    formData.append('accountId', dto.accountId)

    return this.post<IMessageResponseDto, FormData>('accounts/styles', formData)
  }
}

export const accountStylesService = new AccountStylesService()
export default AccountStylesService
